import React from 'react'
import { Route, BrowserRouter as Router } from 'react-router-dom'
import AdminHomepage from './render/Homepage/renderHomepage.jsx'
import AdminHistory from './render/History/renderHistory'
import AdminOrderInfo from './render/OrderInfo/renderOrderInfo'
import SumSubStatus from './render/SumSubStatus/renderSumSubStatus'
import AdminExchangeWays from './render/ExchangeWays/renderExchangeWays'
import ReferralStructure from './render/ReferralStructure/renderReferralStructure'
import PushNotifications from './render/PushNotifications/renderPushNotifications'
import ReportByPeriod from './render/ReportByPeriod/reportByPeriod'
import ProfitByPeriod from './render/ProfitByPeriod/profitByPeriod'
import ErrorOrders from './render/ErrorOrders/errorOrders'
import Promo from './render/Promo/promo'
import CashbackFee from './render/CashbackFee/cashbackFee'
import CashbackBalanceStatistics from './render/CashbackBalanceStatistics/cashbackBalanceStatistics'
import TransactionCheck from './render/KsuCrypto/TransactionCheckETH/transactionCheck'
import ExchangeWaysMatrix from './render/ExchangeWaysMatrix/exchangeWaysMatrix'
import ProviderLazyLoad from './render/ProviderLazyLoad/ProviderLazyLoad'
import NftInfo from './render/NFTInfo/nftInfo.jsx';
import AddressInfo from './render/NFTInfo/addressInfo.jsx';
import CardInfo from './render/CardInfo/cardInfo';
import CPATable from './render/CPATable/cpaTable.jsx'

export default function AdminRouter() {
    return(
        <div style={{flex: '1 1 auto'}}>
            <Router>
                <Route exact path="/skr" component={AdminHomepage} />
                <Route path="/skr/history" component={AdminHistory} />
                <Route path="/skr/exchange-ways/trustee-ways" component={AdminExchangeWays} />
                <Route path="/skr/exchange-ways/matrix" component={ExchangeWaysMatrix} />
                <Route path="/skr/order-info" component={AdminOrderInfo} />
                <Route path="/skr/push-notifications" component={PushNotifications} />
                <Route path="/skr/report-by-period" component={ReportByPeriod} />
                <Route path="/skr/profits-by-period" component={ProfitByPeriod} />
                <Route path="/skr/error-orders" component={ErrorOrders} />
                <Route path="/skr/exchange-rates/cashback-fee" component={CashbackFee} />
                <Route path="/skr/explorer/transaction-check" component={TransactionCheck} />
                <Route path="/skr/provider-lazy-load" component={ProviderLazyLoad} />
                <Route path="/skr/nft-info" component={NftInfo} />
                <Route path="/skr/nft-scanner" component={AddressInfo} />

                <Route path="/skr/user-data/sum-sub-status" component={SumSubStatus} />
                <Route path="/skr/user-data/card-info" component={CardInfo} />

                <Route path="/skr/cashback/referral-structure" component={ReferralStructure} />
                <Route path="/skr/cashback/promo" component={Promo} />
                <Route path="/skr/cashback/balances-statistics" component={CashbackBalanceStatistics} />
                <Route path="/skr/cashback/multiple-balances-reset" component={CPATable} />
            </Router>
        </div>
    )
}
